module.exports = __webpack_public_path__ + "static/media/teaching_icon_2.e1927885.svg";